// ================================================================
// docsUiState — modul-persistenter UI-Zustand der Dokumente-Insel
// ================================================================
// Die Vanilla-Shell (CompanyDashboard) zeichnet per innerHTML neu und mountet
// die Insel dabei FRISCH — React-State überlebt das nicht. Filter, Suche und
// Papierkorb-Modus lebten früher im geteilten `s` der Shell und überstanden
// jedes draw(); dieses Modul ist der 1:1-Ersatz dafür: ein Singleton, das
// Insel UND Shell importieren.
//
// Die Shell schreibt hier nur an zwei Stellen hinein (bewusst dieselben wie
// früher bei s.docFilter/s.trashMode):
//   - «Dokumente» in der Sidebar → filter 'today', Papierkorb zu
//   - Papierkorb-Knopf im Sidebar-Fuss → trashMode an
// Alles andere gehört der Insel.

export interface DocsUiState {
  /** aktiver Filter-Tab (today/all/offer/invoice/gesendet/gesendet_email/gesendet_wa) */
  filter: string;
  /** Live-Suchtext */
  search: string;
  /** Papierkorb-Ansicht offen? */
  trashMode: boolean;
}

export const docsUi: DocsUiState = { filter: 'all', search: '', trashMode: false };

// Dokumentliste zwischen zwei Mounts derselben Insel: ein Shell-draw() (z.B.
// Sprachwechsel, Senden-Dialog) darf keinen Lade-Spinner erzeugen — die Insel
// rendert den letzten Stand sofort und holt die Liste still nach.
import type { DocItem } from './docsHelpers';
export const docsCache: { docs: DocItem[] | null } = { docs: null };
